import _slicedToArray from "/root/Etro/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { createUseExternalEvents } from '@mantine/utils';

var _createUseExternalEve = createUseExternalEvents("mantine-notifications"),
    _createUseExternalEve2 = _slicedToArray(_createUseExternalEve, 2),
    useNotificationsEvents = _createUseExternalEve2[0],
    createEvent = _createUseExternalEve2[1];

var showNotification = createEvent("show");
var hideNotification = createEvent("hide");
var cleanNotifications = createEvent("clean");
var cleanNotificationsQueue = createEvent("cleanQueue");
var updateNotification = createEvent("update");
var notifications = {
  show: showNotification,
  hide: hideNotification,
  clean: cleanNotifications,
  cleanQueue: cleanNotificationsQueue,
  update: updateNotification
};
export { cleanNotifications, cleanNotificationsQueue, createEvent, hideNotification, notifications, showNotification, updateNotification, useNotificationsEvents };